/**
 * @flow
 * @relayHash 1fb9ee3d42fb37392dbfa7643ab4a103
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type OccurrenceDetails_occurrence$ref = any;
type WhatIsThis_occurrence$ref = any;
export type OccurrenceQueryVariables = {|
  id: string
|};
export type OccurrenceQueryResponse = {|
  +occurrence: ?{|
    +id: string,
    +idInt: ?number,
    +identity: ?{|
      +id: string,
      +idInt: ?number,
      +title: string,
      +slug: ?string,
      +commonName: ?{|
        +name: string
      |},
    |},
    +isRequest: boolean,
    +$fragmentRefs: WhatIsThis_occurrence$ref & OccurrenceDetails_occurrence$ref,
  |}
|};
export type OccurrenceQuery = {|
  variables: OccurrenceQueryVariables,
  response: OccurrenceQueryResponse,
|};
*/


/*
query OccurrenceQuery(
  $id: ID!
) {
  occurrence(id: $id) {
    id
    idInt
    identity {
      id
      idInt
      title
      slug
      commonName {
        name
        id
      }
    }
    isRequest
    ...WhatIsThis_occurrence
    ...OccurrenceDetails_occurrence
  }
}

fragment WhatIsThis_occurrence on Occurrence {
  id
  where
  when
  notes
  myPerms
  identity {
    id
    ...PlantLink_plant
  }
  images(first: 20) {
    edges {
      node {
        id
        smallImage: image(width: 860, height: 645) {
          url
        }
        ...ImageThumbnail_image
      }
    }
  }
  revisionCreated {
    createdAt
    author {
      avatar(width: 40, height: 40) {
        url
      }
      username
      ...ProfileLink_user
      id
    }
    id
  }
  ...SuggestionsList_occurrence
}

fragment OccurrenceDetails_occurrence on Occurrence {
  id
  notes
  location {
    coordinates
  }
  images(first: 20) {
    edges {
      node {
        id
        smallImage: image(width: 860, height: 645) {
          url
        }
        ...ImageThumbnail_image
      }
    }
  }
  commenting {
    ...CommentsList_commenting
    id
  }
  document {
    ...RevisionBox_document
    id
  }
  myPerms
  identity {
    id
    idInt
    title
    commonName {
      name
      id
    }
    slug
    ...RankDisplay_plant
    mainImage: images(first: 1) {
      edges {
        node {
          id
          smallImage: image(width: 225, height: 300) {
            url
          }
          ...ImageThumbnail_image
        }
      }
    }
  }
}

fragment ImageThumbnail_image on Image {
  id
}

fragment CommentsList_commenting on Commenting {
  id
  comments(first: 30) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        ...CommentsItem_comment
        __typename
      }
      cursor
    }
  }
}

fragment RevisionBox_document on Document {
  id
  revisionsCount
  revisionTip {
    id
    createdAt
    author {
      username
      ...ProfileLink_user
      id
    }
  }
  revisionCreated {
    createdAt
    author {
      username
      ...ProfileLink_user
      id
    }
    id
  }
}

fragment RankDisplay_plant on LifeNode {
  title
  rankDisplay
  parents {
    id
    idInt
    title
    slug
    rankDisplay
    ...PlantLink_plant
  }
}

fragment PlantLink_plant on LifeNode {
  id
  idInt
  title
  slug
}

fragment ProfileLink_user on User {
  id
  username
  firstName
  reputation
  avatar(width: 40, height: 40) {
    url
  }
}

fragment CommentsItem_comment on Comment {
  id
  myPerms
  body
  document {
    revisionsCount
    id
  }
  revisionCreated {
    createdAt
    author {
      id
      username
      avatar(width: 40, height: 40) {
        url
      }
      ...ProfileLink_user
    }
    id
  }
  voting {
    ...VotingButtons_voting
    id
  }
  commenting {
    id
    count
  }
}

fragment VotingButtons_voting on Voting {
  id
  countUps
  countDowns
  sumValues
  mine {
    id
    value
  }
}

fragment SuggestionsList_occurrence on Occurrence {
  id
  myPerms
  identity {
    id
    ...PlantLink_plant
  }
  suggestions(first: 100) {
    totalCount
    edgeCount
    edges {
      node {
        id
        ...SuggestionItem_suggestionID
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment SuggestionItem_suggestionID on SuggestionID {
  id
  myPerms
  notes
  author {
    avatar(width: 40, height: 40) {
      url
    }
    username
    ...ProfileLink_user
    id
  }
  identity {
    id
    rankDisplay
    description
    ...PlantLink_plant
  }
  voting {
    ...VotingButtons_voting
    id
  }
  revisionCreated {
    createdAt
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "idInt",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isRequest",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rankDisplay",
  "args": null,
  "storageKey": null
},
v9 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  }
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "myPerms",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "avatar",
  "storageKey": "avatar(height:40,width:40)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 40
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 40
    }
  ],
  "concreteType": "File",
  "plural": false,
  "selections": (v9/*: any*/)
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "reputation",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v14/*: any*/),
    (v2/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/)
  ]
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "voting",
  "storageKey": null,
  "args": null,
  "concreteType": "Voting",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "countUps",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "countDowns",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "sumValues",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "mine",
      "storageKey": null,
      "args": null,
      "concreteType": "Vote",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionsCount",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v2/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v13/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "OccurrenceQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "occurrence",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Occurrence",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "identity",
            "storageKey": null,
            "args": null,
            "concreteType": "LifeNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "commonName",
                "storageKey": null,
                "args": null,
                "concreteType": "CommonName",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ]
              }
            ]
          },
          (v7/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "WhatIsThis_occurrence",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "OccurrenceDetails_occurrence",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "OccurrenceQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "occurrence",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Occurrence",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "identity",
            "storageKey": null,
            "args": null,
            "concreteType": "LifeNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "commonName",
                "storageKey": null,
                "args": null,
                "concreteType": "CommonName",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/)
                ]
              },
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "parents",
                "storageKey": null,
                "args": null,
                "concreteType": "LifeNode",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "mainImage",
                "name": "images",
                "storageKey": "images(first:1)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "ImageConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ImageEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Image",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": "smallImage",
                            "name": "image",
                            "storageKey": "image(height:300,width:225)",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "height",
                                "value": 300
                              },
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 225
                              }
                            ],
                            "concreteType": "File",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "where",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "when",
            "args": null,
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "images",
            "storageKey": "images(first:20)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              }
            ],
            "concreteType": "ImageConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ImageEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Image",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": "smallImage",
                        "name": "image",
                        "storageKey": "image(height:645,width:860)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 645
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 860
                          }
                        ],
                        "concreteType": "File",
                        "plural": false,
                        "selections": (v9/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "revisionCreated",
            "storageKey": null,
            "args": null,
            "concreteType": "Revision",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v17/*: any*/),
              (v2/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "suggestions",
            "storageKey": "suggestions(first:100)",
            "args": (v18/*: any*/),
            "concreteType": "SuggestionIDConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "edgeCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SuggestionIDEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SuggestionID",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v11/*: any*/),
                      (v10/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "identity",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LifeNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      (v19/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "revisionCreated",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Revision",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v2/*: any*/)
                        ]
                      },
                      (v20/*: any*/)
                    ]
                  },
                  (v21/*: any*/)
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "suggestions",
            "args": (v18/*: any*/),
            "handle": "connection",
            "key": "Occurrence_suggestions",
            "filters": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "location",
            "storageKey": null,
            "args": null,
            "concreteType": "GeometryObjectType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "coordinates",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "commenting",
            "storageKey": null,
            "args": null,
            "concreteType": "Commenting",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "comments",
                "storageKey": "comments(first:30)",
                "args": (v23/*: any*/),
                "concreteType": "CommentConnection",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CommentEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Comment",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v11/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "body",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "document",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Document",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v2/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "revisionCreated",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Revision",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "author",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "User",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v14/*: any*/),
                                  (v13/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/)
                                ]
                              },
                              (v2/*: any*/)
                            ]
                          },
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "commenting",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Commenting",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "count",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v20/*: any*/)
                        ]
                      },
                      (v21/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "comments",
                "args": (v23/*: any*/),
                "handle": "connection",
                "key": "CommentsList_comments",
                "filters": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "Document",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v24/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "revisionTip",
                "storageKey": null,
                "args": null,
                "concreteType": "Revision",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v25/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "revisionCreated",
                "storageKey": null,
                "args": null,
                "concreteType": "Revision",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v25/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "OccurrenceQuery",
    "id": null,
    "text": "query OccurrenceQuery(\n  $id: ID!\n) {\n  occurrence(id: $id) {\n    id\n    idInt\n    identity {\n      id\n      idInt\n      title\n      slug\n      commonName {\n        name\n        id\n      }\n    }\n    isRequest\n    ...WhatIsThis_occurrence\n    ...OccurrenceDetails_occurrence\n  }\n}\n\nfragment WhatIsThis_occurrence on Occurrence {\n  id\n  where\n  when\n  notes\n  myPerms\n  identity {\n    id\n    ...PlantLink_plant\n  }\n  images(first: 20) {\n    edges {\n      node {\n        id\n        smallImage: image(width: 860, height: 645) {\n          url\n        }\n        ...ImageThumbnail_image\n      }\n    }\n  }\n  revisionCreated {\n    createdAt\n    author {\n      avatar(width: 40, height: 40) {\n        url\n      }\n      username\n      ...ProfileLink_user\n      id\n    }\n    id\n  }\n  ...SuggestionsList_occurrence\n}\n\nfragment OccurrenceDetails_occurrence on Occurrence {\n  id\n  notes\n  location {\n    coordinates\n  }\n  images(first: 20) {\n    edges {\n      node {\n        id\n        smallImage: image(width: 860, height: 645) {\n          url\n        }\n        ...ImageThumbnail_image\n      }\n    }\n  }\n  commenting {\n    ...CommentsList_commenting\n    id\n  }\n  document {\n    ...RevisionBox_document\n    id\n  }\n  myPerms\n  identity {\n    id\n    idInt\n    title\n    commonName {\n      name\n      id\n    }\n    slug\n    ...RankDisplay_plant\n    mainImage: images(first: 1) {\n      edges {\n        node {\n          id\n          smallImage: image(width: 225, height: 300) {\n            url\n          }\n          ...ImageThumbnail_image\n        }\n      }\n    }\n  }\n}\n\nfragment ImageThumbnail_image on Image {\n  id\n}\n\nfragment CommentsList_commenting on Commenting {\n  id\n  comments(first: 30) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        ...CommentsItem_comment\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment RevisionBox_document on Document {\n  id\n  revisionsCount\n  revisionTip {\n    id\n    createdAt\n    author {\n      username\n      ...ProfileLink_user\n      id\n    }\n  }\n  revisionCreated {\n    createdAt\n    author {\n      username\n      ...ProfileLink_user\n      id\n    }\n    id\n  }\n}\n\nfragment RankDisplay_plant on LifeNode {\n  title\n  rankDisplay\n  parents {\n    id\n    idInt\n    title\n    slug\n    rankDisplay\n    ...PlantLink_plant\n  }\n}\n\nfragment PlantLink_plant on LifeNode {\n  id\n  idInt\n  title\n  slug\n}\n\nfragment ProfileLink_user on User {\n  id\n  username\n  firstName\n  reputation\n  avatar(width: 40, height: 40) {\n    url\n  }\n}\n\nfragment CommentsItem_comment on Comment {\n  id\n  myPerms\n  body\n  document {\n    revisionsCount\n    id\n  }\n  revisionCreated {\n    createdAt\n    author {\n      id\n      username\n      avatar(width: 40, height: 40) {\n        url\n      }\n      ...ProfileLink_user\n    }\n    id\n  }\n  voting {\n    ...VotingButtons_voting\n    id\n  }\n  commenting {\n    id\n    count\n  }\n}\n\nfragment VotingButtons_voting on Voting {\n  id\n  countUps\n  countDowns\n  sumValues\n  mine {\n    id\n    value\n  }\n}\n\nfragment SuggestionsList_occurrence on Occurrence {\n  id\n  myPerms\n  identity {\n    id\n    ...PlantLink_plant\n  }\n  suggestions(first: 100) {\n    totalCount\n    edgeCount\n    edges {\n      node {\n        id\n        ...SuggestionItem_suggestionID\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SuggestionItem_suggestionID on SuggestionID {\n  id\n  myPerms\n  notes\n  author {\n    avatar(width: 40, height: 40) {\n      url\n    }\n    username\n    ...ProfileLink_user\n    id\n  }\n  identity {\n    id\n    rankDisplay\n    description\n    ...PlantLink_plant\n  }\n  voting {\n    ...VotingButtons_voting\n    id\n  }\n  revisionCreated {\n    createdAt\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2c77fd35d1ab037f161898b3c60ba0e1';
module.exports = node;
